function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { element, func, node, object, oneOf, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import SovosMenu from "../sovos-menu/SovosMenu";
import SovosMenuItem from "../sovos-menu-item/SovosMenuItem";
import SovosDivider from "../sovos-divider/SovosDivider";
import SovosIconButton from "../sovos-icon-button";
import { findChildrenByType } from "../internals/utils/reactHelpers";
import useMosaicTranslation from "../internals/i18n/useMosaicTranslation";
var StyledIconButton = styled(SovosIconButton)({
  padding: 0
});

/**
 * Icon button that opens a menu. Most often used to show a "more" menu
 */

var SovosIconMenu = function SovosIconMenu(_ref) {
  var children = _ref.children,
    classes = _ref.classes,
    className = _ref.className,
    color = _ref.color,
    dataTestId = _ref['data-testid'],
    _ref$IconButtonProps = _ref.IconButtonProps,
    IconButtonProps = _ref$IconButtonProps === void 0 ? {} : _ref$IconButtonProps,
    iconElement = _ref.iconElement,
    _ref$MenuProps = _ref.MenuProps,
    MenuProps = _ref$MenuProps === void 0 ? {} : _ref$MenuProps,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    size = _ref.size,
    style = _ref.style,
    tooltipText = _ref.tooltipText;
  var _useMosaicTranslation = useMosaicTranslation(),
    t = _useMosaicTranslation.t;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var openMenu = function openMenu(event) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    if (onOpen) {
      onOpen();
    }
  };
  var onMenuClose = function onMenuClose(event) {
    event.stopPropagation();
    setAnchorEl(null);
    if (onClose) {
      onClose();
    }
  };
  var getHandleClick = function getHandleClick(onClick) {
    return function (event) {
      onMenuClose(event);
      if (onClick) {
        onClick();
      }
    };
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledIconButton, _extends({}, IconButtonProps, {
    classes: {
      root: classes === null || classes === void 0 ? void 0 : classes.root
    },
    className: clsx('sovosIconMenu', className),
    color: color,
    "data-testid": dataTestId,
    onClick: openMenu,
    size: size,
    style: style,
    tooltipText: tooltipText || t('open')
  }), iconElement), /*#__PURE__*/React.createElement(SovosMenu, _extends({}, MenuProps, {
    className: "sovosIconMenu__menu",
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    anchorEl: anchorEl,
    onClose: onMenuClose,
    open: Boolean(anchorEl)
  }), findChildrenByType(children, SovosMenuItem, SovosDivider, Divider, MenuItem).map(function (menuItem) {
    var menuItemProps = menuItem.props;
    return menuItem.type === Divider || menuItem.type === SovosDivider ? menuItem : /*#__PURE__*/React.cloneElement(menuItem, _objectSpread(_objectSpread({}, menuItemProps), {}, {
      className: clsx('sovosIconMenu__menuItem', menuItemProps.className),
      onClick: getHandleClick(menuItemProps.onClick)
    }));
  })));
};
SovosIconMenu.propTypes = {
  /**
   * The content of the menu. Must be an array of `SovosMenuItem` or `SovosDivider`
   */
  children: node.isRequired,
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Color of the icon button. Can be 'primary', 'secondary', or a valid
   * css color. Default is the text color.
   */
  color: string,
  /**
   * @ignore
   */
  'data-testid': string,
  /**
   * Object of props passed to the icon button
   */
  IconButtonProps: object,
  /**
   * An icon element for the icon button
   */
  iconElement: element.isRequired,
  /**
   * Object of props passed to the root of the menu
   */
  MenuProps: object,
  /**
   * Callback fired when menu is opened
   */
  onOpen: func,
  /**
   * Callback fired when menu is closed
   */
  onClose: func,
  /**
   * Size of the icon button
   */
  size: oneOf(['extraSmall', 'small', 'medium']),
  /**
   * Inline styles applied to the root element
   */
  style: object,
  /**
   * Tooltip text for the icon button
   */
  tooltipText: string
};
export default SovosIconMenu;